import React, { useEffect, useState } from "react";
import DataTable from "../../../../components/AdminTable/DataTable";
import axios from "axios";
import { apiKey } from "../../../../config/config";
import { languageHelper } from "../../../../config/helperFunctions";
import Select from "react-select";

function SupplierLedger() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: languageHelper("SN"),
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Date"),
      accessorKey: "date",
    },
    {
      header: languageHelper("Reference"),
      accessorKey: "reference_no",
    },
    {
      header: languageHelper("G. Total"),
      accessorKey: "grand_total",
    },
    {
      header: languageHelper("Paid"),
      accessorKey: "paid",
    },
    {
      header: languageHelper("Due"),
      accessorKey: "due",
    },
  ];

  const column = [
    {
      header: languageHelper("SN"),
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Date"),
      accessorKey: "date",
    },
    {
      header: languageHelper("Payment Amount"),
      accessorKey: "due",
    },
    {
      header: languageHelper("Note"),
      accessorKey: "note",
    },
  ];

  const expenseColumns = [
    {
      header: languageHelper("SN"),
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Date"),
      accessorKey: "date",
    },
    {
      header: languageHelper("Invoice Reference"),
      accessorKey: "invoice_reference",
    },
    {
      header: languageHelper("Total Amount"),
      accessorKey: "total_amount",
    },
    {
      header: languageHelper("Paid"),
      accessorKey: "paid",
    },
    {
      header: languageHelper("Due"),
      accessorKey: "due",
    },
  ];

  const expenseFooterConfig = {
    [languageHelper('SN')]: languageHelper("Total") || "Total",
    [languageHelper('Total Amount')]: (rows) =>
      rows
        .reduce((acc, row) => acc + (Number(row.total_amount) || 0), 0)
        .toFixed(2),
    [languageHelper('Paid')]: (rows) =>
      rows.reduce((acc, row) => acc + (Number(row.paid) || 0), 0).toFixed(2),
    [languageHelper('Due')]: (rows) =>
      rows.reduce((acc, row) => acc + (Number(row.due) || 0), 0).toFixed(2),
  };

  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [expenseData, setExpenseData] = useState([]);
  const [suppliers, setSuppliers] = useState([]);

  const [supplier, setSupplier] = useState();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const footerConfig = {
    [languageHelper('SN')]: languageHelper("Total") || "Total",
    [languageHelper('G. Total')]: (rows) =>
      rows
        .reduce((acc, row) => acc + (Number(row.grand_total) || 0), 0)
        .toFixed(2),
    [languageHelper('Paid')]: (rows) =>
      rows.reduce((acc, row) => acc + (Number(row.paid) || 0), 0).toFixed(2),
    [languageHelper('Due')]: (rows) =>
      rows.reduce((acc, row) => acc + (Number(row.due) || 0), 0).toFixed(2),
  };

  const handleSubmit = () => {
    axios
      .get(`${apiKey}/api/rms/admin/supplier-ledger`, {
        params: {
          outletId: user?.user.outlet_id,
          supplierId: supplier,
          from: startDate,
          to: endDate,
        },
      })
      .then((res) => {
        setData(res.data.supplier_ledger);
        setData1(res.data.supplier_due_ledger);
        setExpenseData(res.data.expense_supplier_ledger);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/suppliers`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        setSuppliers(
          res.data.map((item) => ({
            value: item.id,
            label: item.name,
          }))
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }, [user?.token, user.user.outlet_id]);
  return (
    <main className="my-16">
      <div className="text-d-bg-text text-3xl text-center my-4">
        {languageHelper("Supplier Report")}
      </div>
      <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>

      <div className="md:flex block flex-wrap gap-5 ms-4 my-2 items-center ">
        <div className="flex flex-wrap gap-5 ms-4 my-2 items-center justify-center">
          <div>
            <label htmlFor="" className="w-full lg:w-1/3">
              <span className="text-d-bg-text text-sm mb">{languageHelper("Start Date")}</span>
              <div className="mb-2 pt-0">
                <input
                  type="date"
                  className="px-2 py-2 text-gray-500 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  required
                  value={startDate}
                  max={endDate || undefined}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
            </label>
          </div>
          <div>
            <label htmlFor="" className="w-full lg:w-1/3">
              <span className="text-d-bg-text text-sm mb ">{languageHelper("End Date")}</span>
              <div className="mb-2 pt-0">
                <input
                  type="date"
                  className="px-2 py-2 text-gray-500 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  required
                  value={endDate}
                  min={startDate || undefined}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
            </label>
          </div>
          <div>
            <label htmlFor="" className="w-60 inline-block">
              <span className="text-d-bg-text text-sm mb ">{languageHelper("Supplier")}</span>
              <div className="mb-2 pt-0">
                <Select
                  className="text-gray-500 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  options={suppliers}
                  onChange={(e) => setSupplier(e.value)}
                />
              </div>
            </label>
          </div>
        </div>

        <button
          className="bg-d-cat-btn text-white text-sm px-3 text-center py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150 mt-3 w-fit"
          type="button"
          onClick={handleSubmit}
        >
          {languageHelper("Submit")}
        </button>
      </div>
      <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
      <div className="text-d-bg-text text-3md text-center my-4">{languageHelper("Purchase")}</div>

      <DataTable
        columns={columns}
        data={data}
        downloads={true}
        footerConfig={footerConfig}
        showFooter={true}
      />

      <div className="text-d-bg-text text-3md text-center my-4">
        {languageHelper("Due Payment")}
      </div>

      <DataTable columns={column} data={data1} downloads={true} />

      <div className="text-d-bg-text text-3md text-center my-4">
        {languageHelper("Expense Supplier Due")}
      </div>

      <DataTable
        columns={expenseColumns}
        data={expenseData}
        downloads={true}
        footerConfig={expenseFooterConfig}
        showFooter={true}
      />
    </main>
  );
}

export default SupplierLedger;
